// @ts-nocheck
import { SESSION_KEY } from '../../config/general';

export interface SessionStorage<T extends Object> {
    save(data: T): void;
    destroy(): void;
    get(): T | null;
}

export class SessionLocalStorage<T> implements SessionStorage<T> {
    constructor(private key: string = SESSION_KEY) {}

    save(data: T) {
        localStorage.setItem(this.key, JSON.stringify(data));
    }

    destroy() {
        localStorage.removeItem(this.key);
    }

    get() {
        try {
            const val = localStorage.getItem(this.key);

            if (!val) return null;

            return JSON.parse(val);
        } catch (e: any) {
            return null;
        }
    }
}
